import {inject, Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApiUtilService {
  apiUrl = environment.apiUrl;
  apiKey = environment.apiKey;

  http = inject(HttpClient);
  authService = inject(AuthService);
  token!: string | undefined;

  constructor() {
  }

  /**
   * 指定したエンドポイントにリクエストを送信
   */
  async sendPostRequest(path: string, body = {}) {
    const token = await this.authService.getJwtToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': this.apiKey,
      'Authorization': `Bearer ${token}`
    });
    return this.http.post(this.apiUrl + path, body, {headers});
  }
}
